exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fn-modal .ant-modal-content {\n  background-color: transparent;\n  box-shadow: none;\n}", ""]);

// exports
